import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Anchor } from 'components/base';

import PdpIcon from '../product/pdpIcon';

// Phone-only bar at the bottom of the viewport. Each page decides when it shows and what it
// offers. `href` starting with # scrolls within the page.
// `image` is an optional product thumbnail before the text.
const StickyBar = ({ visible, title, meta, sale, href, label, icon, image, onClick }) => {
  const Link = href.startsWith('#') ? 'a' : Anchor;

  return (
    <div className={classNames('lnd-sticky-bar', { visible })}>
      {image && <div className="lnd-sticky-thumb">{image}</div>}
      <div className="lnd-sticky-text">
        <p className="lnd-sticky-title">{title}</p>
        <p className={classNames('lnd-sticky-meta', { 'lnd-sticky-meta--sale': sale })}>{meta}</p>
      </div>
      <Link href={href} className="lnd-btn" onClick={onClick}>
        {label}
        <PdpIcon name={icon} size={15} />
      </Link>
    </div>
  );
};

StickyBar.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  meta: PropTypes.node.isRequired,
  sale: PropTypes.bool,
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  image: PropTypes.node,
  onClick: PropTypes.func,
};

export default StickyBar;
